export var apiDocsTranslations = {
    'en-us': {
        articlesLinkText: 'Articles',
        quickstartsLinkText: 'Quickstarts',
        auth0ApisLinkText: 'Auth0 APIs',
        sdksLinkText: 'SDKs',
        eventCatalogLinkText: 'Events Catalog',
        readyTitleQuickstart: 'Did it work?',
        helpfulText: 'Was this helpful?',
        yesButtonText: 'Yes',
        noButtonText: 'No',
        thanksText: 'Thanks for your feedback!',
        positiveFeedbackTitle: 'Glad to hear that! Any way we can improve?',
        negativeFeedbackTitle: 'Sorry to hear that. How can we help you?',
        sendButton: 'Submit',
        communitySection: "Can't find what you are looking for?  Check out ",
        auth0CommumityText: 'Auth0 Community',
        themeChangeTooltip: 'Change theme',
        logInButton: 'Log In',
        signUpButton: 'Sign Up',
        contactSalesButton: 'Contact sales',
        themeLight: 'Light',
        themeDark: 'Dark',
        themeSystem: 'System',
        searchPlaceholder: 'Search the docs',
        onThisPageText: 'On this Page',
        overview: 'Overview',
    },
    'ja-jp': {
        articlesLinkText: 'ドキュメント',
        quickstartsLinkText: 'クイックスタート',
        auth0ApisLinkText: 'Auth0 API',
        sdksLinkText: 'SDK',
        eventCatalogLinkText: 'イベントカタログ',
        readyTitleQuickstart: '効果はありましたか？',
        helpfulText: 'お役に立ちましたか？',
        yesButtonText: 'はい',
        noButtonText: 'いいえ',
        thanksText: 'フィードバックをありがとうございます！',
        positiveFeedbackTitle: 'ありがとうございます。改善すべき点はありますか？',
        negativeFeedbackTitle: '申し訳ございません。どのようなお手伝いが必要ですか？',
        sendButton: '送信',
        communitySection: 'お探しのものが見つかりませんでしたか？',
        auth0CommumityText: 'Auth0 Community',
        themeChangeTooltip: 'テーマを変更します',
        logInButton: 'ログイン',
        signUpButton: 'サインアップ',
        contactSalesButton: '営業担当に連絡',
        themeLight: 'ライト',
        themeDark: 'ダーク',
        themeSystem: 'システム',
        searchPlaceholder: 'ドキュメントを検索する',
        onThisPageText: 'このページの内容',
        overview: '概要',
    },
    'fr-ca': {
        articlesLinkText: 'Articles',
        quickstartsLinkText: 'Démarrages rapides',
        auth0ApisLinkText: 'API Auth0',
        sdksLinkText: 'Trousses SDK',
        eventCatalogLinkText: "Catalogue d'Événements",
        readyTitleQuickstart: 'Est-ce que cela a fonctionné?',
        helpfulText: 'Cela a-t-il été utile?',
        yesButtonText: 'Oui',
        noButtonText: 'Non',
        thanksText: 'Merci pour votre commentaire!',
        positiveFeedbackTitle: 'Formidable! Comment pouvons-nous nous améliorer?',
        negativeFeedbackTitle: 'Nous sommes désolés. Comment pouvons-nous vous aider?',
        sendButton: 'Soumettre',
        communitySection: 'Vous ne trouvez pas ce que vous cherchez? Consultez',
        auth0CommumityText: 'Communauté Auth0',
        themeChangeTooltip: 'Changer de thème',
        logInButton: 'Connexion',
        signUpButton: 'Inscription',
        contactSalesButton: 'Service de vente',
        themeLight: 'Clair',
        themeDark: 'Foncé',
        themeSystem: 'Système',
        searchPlaceholder: 'Recherche',
        onThisPageText: 'Sur cette page',
        overview: "Vue d'ensemble",
    },
};
